import Keycloak from "keycloak-js";
import { useCallback, useEffect, useState } from "react";
import useDomain from "./useDomain";

interface User {
  keycloak: Keycloak | undefined;
  authenticated: boolean;
  testingRole: string;
  roleActive: string;
  nameUser: string;
}

let initialState = {
  keycloak: undefined,
  authenticated: false,
  testingRole: "",
  roleActive: "",
  nameUser: "",
};

const useAuth = () => {
  const [rolesTesting, setRolesTesting] = useState<string[]>([]);
  const [auth, setAuth] = useState<User>(initialState);
  const [verifyEndpoint, setVerifyEndpoint] = useState<boolean>(false);

  const { run, isSuccess, isLoading, data } = useDomain({
    initState: null,
  });

  let init = useCallback(async () => {
    await run((domain) => domain.valid_authentication_use_case.execute());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!verifyEndpoint) {
      setVerifyEndpoint(() => true);
      init();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (data === null) return;

    const { varKeyloack, varAuthenticated, testingRole, roleActive, nameUser } =
      data;
    setAuth(() => ({
      keycloak: varKeyloack,
      authenticated: varAuthenticated,
      testingRole: testingRole,
      roleActive: roleActive,
      nameUser: nameUser,
    }));
  }, [data]);

  let isValid: boolean | undefined = auth?.keycloak && auth?.authenticated;
  const roleActiveTemp = auth?.roleActive;

  useEffect(() => {
    if (auth.testingRole.length > 0) return;
    setRolesTesting([auth.testingRole]);
    // eslint-disable-next-line
  }, [auth]);

  return {
    auth,
    isSuccess,
    isLoading,
    isValid,
    roleActiveTemp,
    rolesTesting,
  };
};

export default useAuth;
